import React from "react";
import Swal from "sweetalert2";
import { buildAbsoluteDownloadUrl, download } from "../../utils/FileDownload";

export const RenderAttachList = (props) => {
  const downloadFile = (filePath, fileName) => {
    filePath = buildAbsoluteDownloadUrl(filePath);

    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });
    
    download(filePath, fileName);
    
  }
  
  const openFile = (filePath) => {
    const finalURL = buildAbsoluteDownloadUrl(filePath);
    window.open(finalURL, "_blank");
  };
  const fetchIcon = (path) => {
    let ext = path.split('.')
    switch (ext[ext.length - 1]) {
      case 'docx':
      return 'fal fa-file-word';
      break;
      case 'zip':
      return 'fal fa-file-archive';
      break;
      case 'pdf':
      return 'fal fa-file-pdf';
      break;
      case 'xlsx':
      return 'fal fa-file-excel';
      break;
      case 'jpg':
      case 'jpeg':
      case 'png':
      return 'fal fa-file-image';
      break;
      case 'txt':
      return 'fal fa-file-alt';
      break;
      case 'pptx':
      return 'fal fa-file-powerpoint';
      break;
      default:
      return 'fal fa-file';
    }
  }
  
  return (<div className="uploded-files-item feed-pad">
    <div className="uploded-files-item-txt curser"
    data-toggle="tooltip"
    data-placement="right"
    title={props?.fileName}
    onClick={() => openFile(props?.filePath, props?.fileName)}>
    <figure>
    <i className={fetchIcon(props?.filePath)}></i>
    </figure>
    <figcaption >
    <h4 className="oneline-ellipsis font12">{props?.fileName}</h4>
    <p className="font12 hold-show">{props?.size}</p>
    </figcaption>
    </div>
    
    {props.showClose ?
      <button onClick={() => { props.handleRemoveFile(props) }} type="button" className="btn file-remove-btn"><i className="fal fa-times hold-show"></i></button>
      : // remove http:// or https:// from props?.filepath if applciable
      <button type="button"  
        onClick={(e) => {
          e.stopPropagation(); 
          // Phase 2 dual-read: provider 1 (S3) and 2 (R2) are absolute object URLs
          if(String(props.feedbackUploadedFrom) === "1" || String(props.feedbackUploadedFrom) === "2"){
            download(props?.filePath, props?.fileName)
          }else{
            downloadFile(props?.filePath, props?.fileName);
          }
        }} className="btn file-remove-btn rm-box-shadow"><i className="fal fa-download"></i></button>
    }
    </div>
  )
}